"use client"

import { Button } from "@/components/ui/button"

import { openModal } from "@/app/components/Modal"

/**
 * Share button for the post. Opens the share modal.
 */
export function ShareButton() {
  return (
    <Button onClick={() => openModal("share")} aria-label="Share this post">
      Share
    </Button>
  )
}
